import { atomWithReset } from 'jotai/utils';

import { DEFAULT_PAGE, DEFAULT_PER_PAGE, MessageModal } from './types';

export const messageModalState = atomWithReset<MessageModal>({
  isOpen: false,
  currentPanel: 'initial',
  patientId: null,
  profile: null,
  selectedMessageId: null,
  draftMessageId: null,
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PER_PAGE,
  totalPage: 1,
});
